export const getDomainFromEmail = (email = "") => {
  return email.split("@")?.[1];
};

export const getDomainTld = (domainName = "") => {
  const labels = domainName.toLowerCase().replace(/\.$/, "").split(".");
  return labels[labels.length - 1] || "";
};
